export default __webpack_public_path__ + "static/media/postman.61a56023.svg";